import { Route, Routes, Navigate } from "react-router-dom";
import AdminLayout from "../../components/admin-layout";
import React from "react";
import ListClientPlatforms from "./List";
import EditClientPlatform from "./Edit";

export default function ClientPlatforms() {
  return (
    <Routes>
      <Route
        index
        path="/"
        element={
          <AdminLayout noPadding withBackground={false}>
            <ListClientPlatforms />
          </AdminLayout>
        }
      />
      <Route
        path="/:id/*"
        element={
          <AdminLayout noPadding withBackground={false}>
            <EditClientPlatform />
          </AdminLayout>
        }
      />
      <Route path="/create" element={<Navigate to="/client-platforms" replace />} />
    </Routes>
  );
}
